const config = require('core/config').resources.media;
const assignmentService = require('./assignmentService');
const s3Service = require('./s3Service');
const alertUtilities = require('utilities/alertUtilities');

const GENERIC_ERROR_MESSAGE = alertUtilities.messages.GENERIC_ERROR_MESSAGE;

module.exports = {
	// Get Tier 2 eBook by product id
	get: function (productId) {
		let path = '/data/media/ebooks/' + productId + '/' + productId + '.json';
		return s3Service
			.get(path)
			.catch(error => {
				if (error.crossDomain) {
					var params = {
						id: productId
					};

					if (config.cdn) {
						params.source = 'cf';
					} else {
						params.source = 's3';
					}

					return assignmentService.getProduct(params).then(assignmentResponse => {
						if (assignmentResponse && assignmentResponse._ebook) {
							return JSON.parse(assignmentResponse._ebook);
						}

						// Product found, but
						// no ebook found for product
						throw new Error('No eBook found');
					});
				}
				throw error;
			})
			.catch(error => {
				alertUtilities.error(GENERIC_ERROR_MESSAGE);
				throw error;
			});
	}
};
